import styled, { css } from 'styled-components'
import { pxToRem } from 'src/theme'

import Icon from '../../../components/Icon'
import FormLabel from '../FormLabel'

export const Container = styled.div<{ $isDisabled: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;

  ${(props) =>
    props.$isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled(FormLabel)<{ $isDisabled: boolean }>`
  text-transform: none;
  display: flex;
  gap: ${pxToRem(16)};
  margin-bottom: 0;
`

export const LabelText = styled.p<{ $required: boolean; $isError?: boolean }>``

export const Box = styled.span`
  align-self: flex-start;
  display: inline-block;
  position: relative;
`

export const Checkbox = styled.input<{
  $isError?: boolean
}>`
  position: absolute;
  appearance: none;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  cursor: pointer;
  opacity: 0;

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}

  ${(props) =>
    props.$isError &&
    css`
      ${StyledIcon} {
        color: ${props.theme.colors.bordeaux};
      }
    `}
`

export const StyledIcon = styled(Icon)`
  z-index: 1;
  width: ${pxToRem(25)};
  transition: all 0.3s ease;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.m375_bodySmall};
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  font-size: 1.2rem;
  color: grey;
  margin-top: 0.5rem;
`
